module.exports = __webpack_public_path__ + "img/totalNumBG.7d893d0e.png";